import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import NoIndex from "@/components/NoIndex";

type UserRole = "patient" | "dietitian" | "doctor" | "admin";

const ROLE_HOME: Record<UserRole, string> = {
  patient: "/patient-home",
  dietitian: "/dietitian",
  doctor: "/doctor",
  admin: "/admin",
};

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;
}

export const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center gradient-bg">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={requiredRole === "admin" ? "/admin/login" : "/login"} state={{ from: location }} replace />;
  }

  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to={ROLE_HOME[user.role]} replace />;
  }

  return <><NoIndex />{children}</>;
};
